<template>
  <div class="mb-2">
    <aha-checkbox
      @change="handleEnableCopySlideNote"
      v-model="presentation.enableCopySlideNote"
      :disabled="isDisableEditPresentation"
    >
      <span>
        Include slide notes
        <AhaSvg
          class="mb-1 ml-1 text-secondary-20"
          name="question"
          v-tooltip="'Receiver can see your notes when they copy this presentation to their account'"
        />
      </span>
    </aha-checkbox>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PresentationApi from '@/api/presentation'
import Utils from '@/util'
import gaCategories from '@/constant/gaCategories'

export default {
  components: {
  },
  props: {
    presentation: {
      type: Object,
      required: false,
      default() {
        return null
      },
    },
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
    }),
  },
  methods: {
    handleEnableCopySlideNote() {
      PresentationApi.patchPresentation(this.presentation.id, {
        enableCopySlideNote: this.presentation.enableCopySlideNote,
      })
      if (!this.$store.state.presentation.id) {
        if (this.presentation.enableCopySlideNote) {
          Utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Share > Enable copy slide note')
        } else {
          Utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Share > Disable copy slide note')
        }
        return
      }
      if (this.presentation.enableCopySlideNote) {
        Utils.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, 'Editor Header > Enable copy slide note')
      } else {
        Utils.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, 'Editor Header > Disable copy slide note')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
